import { ValidatorFn } from '@angular/forms';
import { SortDirection } from '../../core/utils/sort-utils';

export interface TableColumn {
  name: string;
  width?: string;
  widthMobile?: string;
  align?: 'left' | 'right' | 'center';
  left?: boolean;
  right?: boolean;
  checkbox?: boolean;
  pathData?: {
    name: string;
    type:
      | 'text'
      | 'textarea'
      | 'number'
      | 'date'
      | 'date-relative'
      | 'select'
      | 'boolean'
      | 'multi-select'
      | 'image'
      | 'avatar-select'
      | 'icon-select'
      | 'money-rate'
      | 'checkboxOnTable'
      | 'currency'
      | 'badge'
      | 'color'
      | 'icon'
      | 'html'
      | 'reference-link';
    reverseRate?: boolean;
    nestedPath?: string;
    dateFormat?: string;
    displayFn?: (item: any) => string;
  };
  optionList?: any[];
  validators?: { function: ValidatorFn; message: string; error: string }[];
  defaultValue?: any;
  noVisibleInTable?: boolean;
  noVisibleInForm?: boolean;
  showBorder?: boolean;
  visibility?: 'hidden' | 'visible';
  readonly?: boolean;

  // Propiedades para ordenamiento personalizado
  sortable?: boolean;
  sortFn?: () => void;
  // Clave con la que se ordena la columna, si no debe ser el valor que pinta (CEC-651).
  sortValue?: (item: any) => any;
  sortDirection?: SortDirection;
  ///
  checkboxOnTable?: boolean;
  checkboxSelection?: {
    selectedIds: number[];
    onSelectAll: (selected: boolean) => void;
    onSelectItem: (id: number, selected: boolean) => void;
  };
  
  // Nueva propiedad para filtrado
  filterable?: boolean; // Indica si la columna puede ser filtrada
  groupOptionsFromOptionList?: boolean;
  noVisibleInGrouping?: boolean;

  /** Máximo de líneas a mostrar en celdas tipo html; el resto se trunca con ellipsis */
  maxLines?: number;
}
